import React, { Fragment, useState } from 'react'
import { Modal } from '../common/modal'
import { VideoPlayer } from '../common/videoPlayer'
import './article.sass'

const icons = {
  video: 'video',
  image: 'image',
  article: 'file-alt',
  other: 'file',
  private: 'lock',
}
function VideoPreview(props) {
  let { filename, url, poster } = props

  return (
    <div className="content-file-preview-inner">
      <div className="content-file-preview-actions">
        <a href={url} download={filename} target="_blank" className="content-file-preview-action">
          <i className="fa fa-download" />
          Lataa tiedosto
        </a>
      </div>
      <div className="content-file-preview-video">
        <VideoPlayer src={url} poster={poster} />
      </div>
    </div>
  )
}

function ImagePreview({ url, previewImage, filename, t }) {
  return (
    <div className="content-file-preview-inner">
      <div className="content-file-preview-actions">
        <a href={url} download={filename} target="_blank" className="content-file-preview-action">
          <i className="fa fa-download" />
          {t('common.download')}
        </a>
      </div>
      <div className="content-file-preview-image">
        <img src={previewImage} alt={filename} />
      </div>
    </div>
  )
}

function ArticlePreview({ content, t }) {
  return (
    <div className="content-file-preview-inner">
      <article className="article">
        <div className="article-content" dangerouslySetInnerHTML={{ __html: content }} />
      </article>
    </div>
  )
}

const previewComponent = {
  video: VideoPreview,
  image: ImagePreview,
  article: ArticlePreview,
}

export default function FilePreview(props) {
  let { filename, thumbnail, type, isPublic, review = false, t } = props

  let [open, setOpen] = useState(false)

  const PreviewComponent = previewComponent[type]
  const canOpen = isPublic && typeof PreviewComponent === 'function'

  if (!isPublic) type = 'private'

  let icon = icons[type] || icons.other

  return (
    <Fragment>
      <button
        className={`content-file-preview content-file-preview--${type}`}
        onClick={e => e.preventDefault() & setOpen(true)}
        disabled={!canOpen}>
        {thumbnail ? (
          <div className="content-file-preview-thumbnail">
            <img src={thumbnail} alt={filename} />
          </div>
        ) : (
          <div className="content-file-preview-icon">
            <i className={`fa fa-${icon}`} />
          </div>
        )}
        <div className="content-file-preview-name">
          <span>
            {filename}
            {review ? (
              <span className="content-file-preview-name-review">
                <i className="fa fa-check" />
              </span>
            ) : null}
          </span>
        </div>
      </button>
      {open && (
        <Modal title={t('content.preview')} description={filename} onClose={() => setOpen(false)}>
          <PreviewComponent {...props} />
        </Modal>
      )}
    </Fragment>
  )
}
